import { RootState } from 'app/store';

export const selectThinfinityVisibility = (state: RootState) => state.thinfinity.hidden;

export const selectThinfinityTittle = (state: RootState) => state.thinfinity.tittle;

export const selectData = (state: RootState) => state.thinfinity.data;